import { Button } from '../../atoms';
import { CSSObject } from '@emotion/styled';
import { GroupBase, SingleValue, StylesConfig } from 'react-select';
import { IUserDropdown } from '../../../types';
import AsyncSelect from 'react-select/async';
import React from 'react';
import useStyles from './AddUser.styles';

interface IAddUser {
  inputChangeHandler: (userName: string) => Promise<IUserDropdown[]> | void;
  addCanaryUserHandler: () => void;
  addCanaryUsersFromFileHandler: () => void;
  deleteCanaryUsersFromFileHandler: () => void;
  deleteAllCanaryUsersHandler: () => void;
  onChangeHandler: (
    selectedOption: SingleValue<IUserDropdown>,
    action: { action: string },
  ) => void;
  isAddUserEnabled: boolean;
  isAdmin: boolean;
  isFullAdmin: boolean;
  value: SingleValue<IUserDropdown> | undefined;
}

export const AddUser: React.FC<IAddUser> = ({
  inputChangeHandler,
  addCanaryUserHandler,
  addCanaryUsersFromFileHandler,
  deleteCanaryUsersFromFileHandler,
  deleteAllCanaryUsersHandler,
  onChangeHandler,
  isAddUserEnabled,
  isAdmin,
  isFullAdmin,
  value,
}) => {
  const classes = useStyles();
  const handleInputChange = (userName: string) => inputChangeHandler(userName);
  const handleAddCanaryUserClick = () => addCanaryUserHandler();
  const handleAddCanaryUsersFromFileClick = () =>
    addCanaryUsersFromFileHandler();
  const handleDeleteCanaryUsersFromFileClick = () =>
    deleteCanaryUsersFromFileHandler();
  const handleDeleteAllCanaryUsersClick = () => deleteAllCanaryUsersHandler();
  const handleOnChange = (
    selectedOption: SingleValue<IUserDropdown>,
    action: { action: string },
  ) => onChangeHandler(selectedOption, action);

  const customizedStyles: StylesConfig<
    IUserDropdown,
    false,
    GroupBase<IUserDropdown>
  > = {
    menu: (provided: CSSObject) => ({ ...provided, zIndex: 9999 }),
  };

  const formatOptionLabel = (option: IUserDropdown) => (
    <div className={classes.optionLabel}>
      <div className={classes.userPrincipalName}>{option.value}</div>
      <div>{option.label}</div>
    </div>
  );

  return (
    <div className={classes.addUserBlock}>
      <div className={classes.input}>
        <AsyncSelect
          cacheOptions
          isClearable
          loadOptions={handleInputChange}
          noOptionsMessage={() => 'no matches found'}
          styles={customizedStyles}
          formatOptionLabel={formatOptionLabel}
          onChange={handleOnChange}
          value={value}
          placeholder={'Enter a user to add'}
        />
      </div>
      <div className={classes.addButton}>
        <Button
          onAction={handleAddCanaryUserClick}
          size="medium"
          disabled={!isAddUserEnabled}
        >
          Add
        </Button>
      </div>
      <div className={classes.addButton}>
        <Button onAction={handleAddCanaryUsersFromFileClick} size="medium">
          Add from file
        </Button>
      </div>
      {(isAdmin || isFullAdmin) && (
        <div className={classes.addButton}>
          <Button onAction={handleDeleteCanaryUsersFromFileClick} size="medium">
            Delete from file
            <i data-qa-name={'delete_from_file_button'} />
          </Button>
        </div>
      )}
      {isFullAdmin && (
        <div>
          <Button onAction={handleDeleteAllCanaryUsersClick} size="medium">
            Delete all
          </Button>
        </div>
      )}
    </div>
  );
};
